import React, { useEffect, useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { apiFetch, formatDateForInput } from "api/Api";
import { Link } from "react-router-dom";
import BASE_URL from "api/Api";
import "assets/theme/admin_list.css";
import { FaCalendarAlt, FaPlus, FaEdit, FaTrash } from "react-icons/fa";

const JanataDarbarList = () => {
  const [darbars, setDarbars] = useState([]);
  const [loading, setLoading] = useState(true);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;

  const loadDarbars = async (currentPage = 1) => {
    setLoading(true);
    try {
      const res = await apiFetch(
        `leader_admin/get_all_janta_darbar?page=${currentPage}&limit=${limit}`
      );

      setDarbars(res.data || []);
      setTotalPages(res.totalPages || 1);
      setPage(res.page || 1);
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDarbars(page);
  }, [page]);

  const getStatusBadge = (item) => {
    let status = item.status;

    if (status !== "Cancelled" && item.darbar_date) {
      const todayStr = formatDateForInput(new Date());
      const eventDateStr = formatDateForInput(item.darbar_date);

      if (eventDateStr < todayStr) {
        status = "Completed";
      } else {
        status = "Scheduled";
      }
    }

    switch (status) {
      case "Completed":
        return <span className="badge-status badge-status-success">पूर्ण (Completed)</span>;
      case "Cancelled":
        return <span className="badge-status badge-status-danger">रद्द (Cancelled)</span>;
      default:
        return <span className="badge-status badge-status-warning">नियोजित (Scheduled)</span>;
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("तुम्हाला हा दरबार हटवायचा आहे याची खात्री आहे का?")) return;

    try {
      await apiFetch(`leader_admin/delete_janta_darbar/${id}`, { method: "DELETE" });
      alert("दरबार यशस्वीरीत्या हटवला गेला");
      loadDarbars(page);
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="admin-page-container">
        {/* Header */}
        <div className="admin-header-card d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="d-flex align-items-center">
            <div className="admin-header-icon">
              <FaCalendarAlt />
            </div>
            <div>
              <h4 className="admin-header-title">जनता दरबार व्यवस्थापन यादी</h4>
              <p className="admin-header-subtitle mb-0">
                जनता दरबार कार्यक्रम, तारीख, वेळ आणि स्थिती व्यवस्थापित करा
              </p>
            </div>
          </div>
          <Link to="/add_janta_darbar" className="btn-admin-add">
            <FaPlus /> नवीन दरबार जोडा
          </Link>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-warning" role="status" />
              <p className="mt-2 text-muted fw-semibold">जनता दरबार लोड होत आहेत...</p>
            </div>
          ) : darbars.length === 0 ? (
            <div className="text-center py-5 text-muted">
              कोणताही जनता दरबार आढळला नाही.
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-admin-custom">
                  <thead>
                    <tr>
                      <th>Sr. No.</th>
                      <th>बॅनर (Banner)</th>
                      <th>शीर्षक (Title)</th>
                      <th>आयोजक (Organizer)</th>
                      <th>दिनांक व वेळ</th>
                      <th>स्थळ (Venue)</th>
                      <th>स्थिती</th>
                      <th className="text-end">कृती (Actions)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {darbars.map((item, index) => (
                      <tr key={item.darbar_id}>
                        <td className="fw-bold text-secondary">
                          {(page - 1) * limit + index + 1}
                        </td>
                        <td>
                          {item.banner ? (
                            <img
                              src={`${BASE_URL}${item.banner}`}
                              alt="बॅनर"
                              className="admin-table-thumb"
                            />
                          ) : (
                            <span className="text-muted small">नाही</span>
                          )}
                        </td>
                        <td className="fw-bold text-dark">{item.title}</td>
                        <td className="text-secondary">{item.organizer}</td>
                        <td>
                          <div className="fw-semibold text-dark">
                            {new Date(item.darbar_date).toLocaleDateString("mr-IN")}
                          </div>
                          <small className="text-muted">
                            {item.start_time} - {item.end_time}
                          </small>
                        </td>
                        <td className="text-secondary">{item.venue}</td>
                        <td>{getStatusBadge(item)}</td>
                        <td className="text-end">
                          <div className="admin-action-group justify-content-end">
                            <Link
                              to={`/edit_janata_darbar/${item.darbar_id}`}
                              className="btn-action-icon btn-action-edit"
                              title="संपादित करा"
                            >
                              <FaEdit />
                            </Link>
                            <button
                              className="btn-action-icon btn-action-delete"
                              onClick={() => handleDelete(item.darbar_id)}
                              title="हटवा"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination Bar */}
              <div className="admin-pagination-bar">
                <span className="admin-pagination-info">
                  पृष्ठ {page} पैकी {totalPages}
                </span>

                <div className="d-flex align-items-center gap-2">
                  <button
                    className="admin-pagination-btn"
                    disabled={page === 1}
                    onClick={() => setPage(page - 1)}
                  >
                    « मागील
                  </button>

                  {[...Array(totalPages)].map((_, i) => (
                    <button
                      key={i}
                      className={`admin-pagination-btn ${page === i + 1 ? "active" : ""}`}
                      onClick={() => setPage(i + 1)}
                    >
                      {i + 1}
                    </button>
                  ))}

                  <button
                    className="admin-pagination-btn"
                    disabled={page === totalPages}
                    onClick={() => setPage(page + 1)}
                  >
                    पुढील »
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default JanataDarbarList;
